import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Attempt, EligibleRecord } from "types";
import { formatLongEligibleRecord } from "util/records";
import { useRecordAttempts } from "util/useRecordAttempts";
import { useDisplaySettings } from "./DisplaySettingsProvider";
import range from "lodash/range";

const editData: EligibleRecord = {
  location: "W",
  competitionType: "FP",
  gender: "MALE",
  divisionCode: "M1",
  weightClass: "63kg",
  equipmentLevel: "RAW",
  tested: "T",
  lift: "S",
};

const RecordInfo = ({
  currentAttempt,
  id,
}: {
  currentAttempt: Attempt | undefined | null;
  id: string;
}) => {
  const { maxRecordsToShow } = useDisplaySettings();
  const { editMode } = useDisplaySettings();
  const allRecords = useRecordAttempts();

  const recordsForAttempt = currentAttempt
    ? allRecords?.[currentAttempt._id]
    : [];

  return (
    <DisplayComponent style={{ top: 138, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          width: sizeMultiplier * 600,
        };

        let recordAttempt: React.ReactNode = "";
        if (currentAttempt?.worldRecord) {
          recordAttempt = <span>World Record Attempt</span>;
        } else if (currentAttempt?.regionalRecord) {
          recordAttempt = <span>Regional Record Attempt</span>;
        } else if (
          currentAttempt?.stateRecord &&
          currentAttempt?.americanRecord
        ) {
          recordAttempt = <span>State and American Record Attempt</span>;
        } else if (
          currentAttempt?.stateRecord &&
          currentAttempt?.nationalRecord
        ) {
          recordAttempt = <span>State and National Record Attempt</span>;
        } else if (currentAttempt?.stateRecord) {
          recordAttempt = <span>State Record Attempt</span>;
        } else if (currentAttempt?.americanRecord) {
          recordAttempt = <span>American Record Attempt</span>;
        } else if (
          currentAttempt?.provincialRecord &&
          currentAttempt?.canadianRecord
        ) {
          recordAttempt = <span>Canadian and Provincial Record Attempt</span>;
        } else if (currentAttempt?.canadianRecord) {
          recordAttempt = <span>Canadian Record Attempt</span>;
        } else if (
          currentAttempt?.nationalRecord &&
          currentAttempt?.provincialRecord
        ) {
          recordAttempt = <span>Provincial and National Record Attempt</span>;
        } else if (currentAttempt?.provincialRecord) {
          recordAttempt = <span>Provincial Record Attempt</span>;
        } else if (currentAttempt?.nationalRecord) {
          recordAttempt = <span>National Record Attempt</span>;
        }

        if (editMode) {
          return (
            <div style={style} className="lifter-details">
              {recordAttempt}
              {range(maxRecordsToShow).map(() => {
                return (
                  <div>
                    RECORD:{" "}
                    {formatLongEligibleRecord({
                      record: editData,
                    })}
                  </div>
                );
              })}
            </div>
          );
        }

        return (
          <div style={style} className="lifter-details">
            {recordAttempt}
            {recordsForAttempt?.map((record, index) => {
              if (index >= maxRecordsToShow) {
                return null;
              }

              return (
                <div>
                  RECORD:{" "}
                  {formatLongEligibleRecord({
                    record,
                  })}
                </div>
              );
            })}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default RecordInfo;
